import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    putAdministracionTiposPublicacion,
    deleteAdministracionTiposPublicacion,
    postTiposPublicacionAsociarGrupoPlanes
} from '../../api/axios';
import {
    setTiposPublicacion,
    fetchTiposPublicacionAdmById,
    setTiposGrupoPlanes,
    updateListTiposPublicaciones,
} from '../../actions/tiposPublicacionActions';
import {
    setId,
    setPlanes,
    setPlanesDesdeBusqueda,
    setDataGrupoCopy,
    setDataGrupo
} from '../../actions/planesActions';
import ModalItem from '../General/Modal';
import { editando } from '../../actions/generalActios';
import { toast } from 'react-toastify';
import GoBackArrow from '../General/GoBackArrow';

// Wrapper para usar hooks en class component
function TipoPublicacionesEditWrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <TipoPublicacionesEdit {...props} navigate={navigate} location={location} />;
}


class TipoPublicacionesEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comision: "",
            descripcion: "",
            cambioInputChange: false,
            comisionPredeterminada: "",
            cantidadCuotas: ""
        };
        this.descripcionInputRef = React.createRef();
    };

    componentDidMount() {
        this.props.fetchTiposPublicacionAdmById({
            idTipoPublicacion: this.props.setTipoPublicacion.id,
            cantidadPagina: 10,
            numeroPagina: 1,
            Estado: null,
            descripcion: ""
        });

        if (this.descripcionInputRef.current) {
            this.descripcionInputRef.current.focus();
        }
    }

    /*
    onSubmit = async (event) => {
        event.preventDefault();

        let { id, descripcion, comision, cantidadCuotas } = this.props.setTipoPublicacion;
        let request = {
            idTipoPublicacion: id,
            descripcion: descripcion,
            comision: parseFloat(comision),
            cantidadCuotas: parseInt(cantidadCuotas)
        }
        let guardar = putAdministracionTiposPublicacion(request);
        guardar.then(res => {
            toast.success("Tipo de publicacion modificada");
            if (this.props.tiposGruposPlanes != undefined) {
                this.asociarGrupoPlanes(this.props.setTipoPublicacion.id);
            }
            //this.props.updateListTiposPublicaciones(this.props.tiposPublicaciones, request);
            this.goToTipoPublicaciones();
        }).catch(err => {
            toast.error("El tipo de publicacion no pudo ser modificado");
        })
    }*/
    onSubmit = async (event) => {
        event.preventDefault();

        let { id, descripcion, comision, cantidadCuotas } = this.props.setTipoPublicacion;
        let request = {
            idTipoPublicacion: id,
            descripcion: descripcion,
            comision: parseFloat(comision),
            cantidadCuotas: parseInt(cantidadCuotas)
        }
        let guardar = putAdministracionTiposPublicacion(request);
        guardar.then(res => {
            this.props.updateListTiposPublicaciones(this.props.tiposPublicaciones, request)
                .then(() => {
                    toast.success("Tipo de publicacion modificada");
                    if (this.props.tiposGruposPlanes != undefined) {
                        this.asociarGrupoPlanes(this.props.setTipoPublicacion.id);
                    }
                    this.goToTipoPublicaciones();
                })
                .catch(err => {
                    console.error("Error al actualizar la lista de Tipos de Publicaciones:", err);
                    toast.error("No pudo modificarse");
                });
        }).catch(err => {
            toast.error("El tipo de publicacion no pudo ser modificado");
        })
    }

    asociarGrupoPlanes = (id) => {
        let elementIdGrupo = null;
        let arrayIdsElement = [];
        for (let index = 0; index < this.props.tiposGruposPlanes.length; index++) {
            elementIdGrupo = this.props.tiposGruposPlanes[index].idGrupoPlan;
            arrayIdsElement.push(elementIdGrupo);
        }
        let data = {
            idTipoPublicacion: id,
            listaIdsGrupoPlanes: arrayIdsElement
        }

        let asociarGrupoPlanes = postTiposPublicacionAsociarGrupoPlanes(data);
        asociarGrupoPlanes.then(res => {
            toast.success("Se asociaron grupos de planes");
        }).catch(err => { });
    }

    onDelete = () => {
        const req = deleteAdministracionTiposPublicacion(this.props.tipoPublicacion.codigo);
        req.then(res => {
            toast.success("Tipo de publicación borrado");
            this.goToTipoPublicaciones();
        }).catch(err => {
            toast.error("No se pudo realizar esta tarea");
        });
    }

    goToBusquedaPlanes = () => {
        if (JSON.stringify(this.props.tiposGruposPlanes) == "[]") {

            this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes);
        }

        this.props.editando(true);
        this.props.navigate("/Tipo/Publicaciones/GrupoPlanes/Busqueda");
    }

    goToPlan = (idGrupoPlan) => {
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setDataGrupoCopy({})
        this.props.setPlanes([]);
        this.props.setId(idGrupoPlan);
        this.props.navigate(`/Planes/Editar/${idGrupoPlan}`, { state: { from: this.props.location.pathname } });
    }

    goToTipoPublicaciones = () => {
        this.props.navigate("/Tipo/Publicaciones");
    }

    //setData_tiposGruposPlanes = () => {
    //    if (JSON.stringify(this.props.tiposGruposPlanes) == "[]") {
    //        this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes);
    //    }
    //}

    //borrarFila = (idGrupoPlan) => {

    //    if (JSON.stringify(this.props.tiposGruposPlanes) == "[]") {
    //        this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes);
    //    }
    //    let grupoPlanes = JSON.stringify(this.props.tipoPublicacion.grupoPlanes);
    //    if (grupoPlanes != "[]") {
    //        let index = this.props.tipoPublicacion.grupoPlanes.findIndex(x => x.idGrupoPlan == idGrupoPlan);
    //        this.props.tipoPublicacion.grupoPlanes.splice(index, 1);
    //        this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes);
    //        this.forceUpdate();
    //    }
    //}


    setData_tiposGruposPlanes = () => {
        if (JSON.stringify(this.props.tiposGruposPlanes) == "[]") {
            //setTimeout(() => {
            //    this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes);
            //}, 5000);
            this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes);
        }
    }

    borrarFila = (idGrupoPlan) => {
        this.props.editando(true);
        this.setData_tiposGruposPlanes();

        setTimeout(() => {
            let grupoPlanes = [...this.props.tiposGruposPlanes];
            if (grupoPlanes.length > 0) {
                const index = grupoPlanes.findIndex(x => x.idGrupoPlan == idGrupoPlan);
                if (index !== -1) {
                    grupoPlanes.splice(index, 1);
                    this.props.setTiposGrupoPlanes(grupoPlanes);
                }
            } else {
                let currentList = this.props.tiposGruposPlanes && this.props.tiposGruposPlanes.length > 0
                    ? [...this.props.tiposGruposPlanes]
                    : [...(this.props.tipoPublicacion.grupoPlanes || [])];

                const index = currentList.findIndex(x => x.idGrupoPlan == idGrupoPlan);
                if (index !== -1) {
                    currentList.splice(index, 1);
                    this.props.setTiposGrupoPlanes(currentList);
                }
            }
        }, 50);
    }


    tablaGrupos = () => {
        let dataSource = [];
        const reduxData = this.props.tiposGruposPlanes;
        const savedData = this.props.tipoPublicacion.grupoPlanes;
        const esEdicion = this.props.esEdicion;

        if (esEdicion) {
            dataSource = reduxData || [];
        } else {
            if (reduxData && reduxData.length > 0) {
                dataSource = reduxData;
            } else {
                dataSource = savedData || [];
            }
        }

        if (!dataSource || dataSource.length === 0) return null;

        return dataSource.map((item, index) => (
            <div className="list-group" key={item.idGrupoPlan || index}>
                <a onClick={() => this.goToPlan(item.idGrupoPlan)} style={{ cursor: 'pointer' }}>
                    <div className="list-group-item hover-background-color">
                        <div className="row justify-content-between align-items-center">

                            <div className="col-2 col-md-1">
                                <h6 className="box-title font-weight-bold text-center">{item.idGrupoPlan}</h6>
                            </div>

                            <div className="col-6 col-md-6 text-break">
                                <small className="font-14 applyFont">{item.descripcion}</small>
                            </div>
                            <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
                                <small className="font-14 applyFont">{item.comision}</small>
                                <i className="fas fa-percent mx-1" />
                            </div>
                            <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
                                <i className="fas fa-trash-alt text-danger"
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => { e.stopPropagation(); this.borrarFila(item.idGrupoPlan); }} />
                            </div>

                        </div>
                    </div>
                </a>
            </div>
        ));
    }



    tablaGrupos2 = () => {
        let jsonData = JSON.stringify(this.props.tiposGruposPlanes);

        if ((jsonData != "[]" && jsonData != undefined) || (this.props.tipoPublicacion.grupoPlanes != undefined)) {
            var rows = [];
            let htmlData;

            this.props.tipoPublicacion.grupoPlanes.map((item, index) => {

                htmlData =
                    <div className="list-group" key={index}>
                        <a onClick={() => this.goToPlan(item.idGrupoPlan)}>
                            <div className="list-group-item hover-background-color">
                                <div className="row justify-content-between align-items-center">

                                    <div className="col-2 col-md-1">
                                        <h6 className="box-title font-weight-bold text-center">{item.idGrupoPlan}</h6>
                                    </div>

                                    <div className="col-6 col-md-6 text-break">
                                        <small className="font-14 applyFont">{item.descripcion}</small>
                                    </div>
                                    <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
                                        <small className="font-14 applyFont">{item.comision}</small>
                                        <i className="fas fa-percent mx-1" />
                                    </div>
                                    <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
                                        <i className="fas fa-trash-alt"
                                            onClick={(e) => (e.stopPropagation(), this.borrarFila(item.idGrupoPlan))} />
                                    </div>

                                </div>
                            </div>
                        </a>
                    </div>
                rows.push(htmlData);

            });
            return rows;
        }

    }


    inputChange = (e) => {

        var numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;

        if (e.target.name === "comision") {

            let esNumero = valor.match(numbersOnly);

            if (esNumero == null) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: "" });
                return;
            }

            if (e.target.value >= 100) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: 100 });
            } else {
                this.setState({ cambioInputChange: true, comisionPredeterminada: valor });
                let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor };
                this.props.setTiposPublicacion(estado);
            }
        } else {
            let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor }
            this.props.setTiposPublicacion(estado);
        }
    }


    render() {
        let descripcion, comision, cantidadCuotas
        if (this.state.cambioInputChange) {
            comision = this.state.comisionPredeterminada;
        } else {
            descripcion = this.props.setTipoPublicacion.descripcion != undefined ? this.props.setTipoPublicacion.descripcion : this.props.tipoPublicacion.descripcion;
            comision = this.props.setTipoPublicacion.comision != undefined ? this.props.setTipoPublicacion.comision : this.props.tipoPublicacion.comision;
            cantidadCuotas = this.props.setTipoPublicacion.cantidadCuotas != undefined ? this.props.setTipoPublicacion.cantidadCuotas : this.props.tipoPublicacion.cantidadCuotas;
        }

        return (
            <div className="container card">
                <div className="row justify-content-between align-items-center card-body p-4">

                    <div className="col-10 col-md-5 mb-4">
                        <GoBackArrow />
                        <h4 className="card-title d-block d-sm-inline">Editar Tipo de publicación</h4>
                    </div>

                    <div className="col-2 col-md-auto button-group">
                        <button
                            type="button"
                            onClick={this.goToBusquedaPlanes}
                            className="btn btn-sm background-rojo-megatone m-r-10"
                        >
                            <i className="fa fa-plus-circle" /> Agregar Grupo de Planes
                        </button>
                    </div>

                    <form className="col-12 form-horizontal form-material" onSubmit={this.onSubmit}>
                        <div className="form-group">
                            <div className="row justify-content-evenly">

                                <div className="col-4 col-md-4">

                                    <label className="label-oscura">Descripción</label>
                                    <input
                                        name="descripcion"
                                        value={descripcion}
                                        onChange={this.inputChange}
                                        type="text"
                                        id="firstName"
                                        className="form-control"
                                        ref={this.descripcionInputRef}
                                    />
                                </div>

                                <div className="col-4 col-md-4">

                                    <small className="font-14 applyFont">
                                        <i className="fas fa-percent mx-1" />
                                    </small>

                                    <label className="label-oscura">Comisión</label>
                                    <input
                                        name="comision"
                                        value={comision}
                                        onChange={this.inputChange}
                                        type="text"
                                        className="form-control"
                                        maxLength="5"
                                    />
                                </div>

                                <div className="col-4">
                                    <label className="label-oscura">Numero Cuotas</label>
                                    <input
                                        name="cantidadCuotas"
                                        value={cantidadCuotas}
                                        onChange={this.inputChange}
                                        type="text"
                                        className="form-control"
                                        maxLength="5"
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="col-10 col-md-5">
                            <label className="label-oscura">Grupos de Planes</label>
                        </div>
                        {this.tablaGrupos()}

                        <div className="row align-items-center justify-content-center mb-3 text-center mt-3">

                            <button
                                onClick={this.onSubmit}
                                className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                            >
                                Guardar
                            </button>

                            <ModalItem
                                text="¿Desea eliminar el tipo de publicación?"
                                onDelete={this.onDelete}
                                show={this.state.showModal}
                                btnText="Eliminar"
                                btnStyle="btn btn-sm btn-grey col-auto mx-2"
                            />

                            <button
                                onClick={this.goToTipoPublicaciones}
                                className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                            >
                                Cancelar
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    esEdicion: state.general.editando,
    tipoPublicacion: state.tiposPublicacion.tiposPublicacion,
    tiposGruposPlanes: state.tiposPublicacion.tiposGruposPlanes,
    setTipoPublicacion: state.tiposPublicacion.setTiposPublicacion,
    tiposPublicaciones: state.tiposPublicacion.tiposPublicaciones,
});

export default connect(mapStateToProps, {
    fetchTiposPublicacionAdmById,
    setTiposPublicacion,
    setTiposGrupoPlanes,
    editando,
    setId,
    setPlanes,
    setDataGrupo,
    setDataGrupoCopy,
    setPlanesDesdeBusqueda,
    updateListTiposPublicaciones,
})(TipoPublicacionesEditWrapper);